/* eslint-disable @nx/enforce-module-boundaries */
import { ModuleWithProviders } from '@angular/core';
import { NavigationState } from '@daas-consulting/core-frontend-store_navigation';
import * as ageGroupsStore from '@daas-consulting/production/age_groups/frontend/store';
import {
  congrats,
  download,
  errorMessage,
  loader,
} from '@daas-consulting/production/shared/frontend/store';
import * as SecurityAuditSore from '@daas-consulting/security/audit/frontend/store';
import * as securityAuthenticationStore from '@daas-consulting/security/authentication/frontend/store';
import { AuthenticationState } from '@daas-consulting/security/authentication/frontend/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';
import { environment } from '../environments/environment';

const ngxsPlugins: ModuleWithProviders<unknown>[] = [
  NgxsFormPluginModule.forRoot(),
  NgxsReduxDevtoolsPluginModule.forRoot({
    disabled: environment.prod,
    trace: !environment.prod,
  }),
  NgxsRouterPluginModule.forRoot(),
  NgxsResetPluginModule.forRoot(),
  !environment.prod && environment.loggerEnabled
    ? NgxsLoggerPluginModule.forRoot()
    : undefined,
]
  .filter((x) => x)
  .map((x) => x as ModuleWithProviders<unknown>);

export const appModules = [
  NgxsModule.forRoot(
    [
      loader.state.LoaderState,
      congrats.state.LoaderState,
      download.state.DownloadState,
      errorMessage.state.ErrorMessageState,
      AuthenticationState,
      SecurityAuditSore.state.AuditDetailPreviewState,
      NavigationState,
    ],
    {
      selectorOptions: {
        suppressErrors: false,
        injectContainerState: false,
      },
      compatibility: { strictContentSecurityPolicy: true },
    }
  ),
  NgxsStoragePluginModule.forRoot({
    key: [
      ageGroupsStore.list.consts.stateTokenName,
      securityAuthenticationStore.consts.stateTokenName,
    ],
  }),
  ...ngxsPlugins,
];
